import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
class BlockSelectComponent extends Vue {

  @Prop({ default: null, type: [Object, String, Number, null] })
  value: any | null

  @Prop({ default: () => ['item 1', 'item 2'], type: [Array] })
  options: string[] | any[];

  @Prop({ type: [Object, Array] })
  rules: any;

  @Prop({ default: 'name', type: [String] })
  itemText: string | null;

  @Prop({ default: 'id', type: [String] })
  itemValue: string | null;


  @Prop({ default: null, type: [String] })
  label: string | null;


  @Prop({ default: false, type: [Boolean] })
  required: boolean;

  @Prop({ default: false, type: [Boolean] })
  error: boolean;

  @Prop({ default: false, type: [Boolean] })
  disabled: boolean;

  get vModel(): any | null { return this.value; }
  set vModel(value: any | null) { this.$emit('input', value); }

  handleChange(event: any) {
    if (typeof event !== 'object') {
      const option = (this.options as any[]).find(item => item.id === event);
      this.$emit('change', option)
      return;
    }
    this.$emit('change', event)
  }

}

export default BlockSelectComponent;


// WEBPACK FOOTER //
// ./src/components/block-select/index.ts